/* global Backbone, window */
window.Replication = Backbone.Model.extend({
  defaults: {
    state: {},
    server: {}
  },
  initialize: function initialize() {}
});